"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogBuilder = void 0;
const configuration_1 = require("../configuration/configuration");
const server_log_scheduler_1 = require("../output/server/server-log-scheduler");
const browser_storage_1 = require("../output/server/storage/browser-storage");
const create_console_logger_1 = require("../output/create-console-logger");
const uuid_1 = require("uuid");
function LogBuilder() {
    const configuration = configuration_1.DefaultConfiguration;
    let storageStrategy;
    const builder = {
        enableConsole(conf) {
            configuration.console = {
                enabled: true,
                minLevel: conf === null || conf === void 0 ? void 0 : conf.minLevel,
            };
            return builder;
        },
        setAuthTokenFactory(factory) {
            configuration.authTokenFactory = factory;
            return builder;
        },
        setApplicationHeader(factory) {
            configuration.applicationHeaderFactory = factory;
            return builder;
        },
        enableServerLogs(serverLogConfiguration) {
            configuration.serverLogConf = Object.assign({ enabled: true }, serverLogConfiguration);
            storageStrategy = new browser_storage_1.BrowserStorage(serverLogConfiguration.storeName);
            return builder;
        },
        build() {
            const { authTokenFactory, serverLogConf, console: consoleConf, applicationHeaderFactory } = configuration;
            const consoleLogger = (0, create_console_logger_1.createConsoleLogger)(consoleConf);
            const loggingSessionId = (0, uuid_1.v4)();
            const serverLogScheduler = serverLogConf.enabled
                ? (0, server_log_scheduler_1.makeScheduler)(serverLogConf, storageStrategy, authTokenFactory, applicationHeaderFactory)
                : null;
            function structuredLog(level, messageTemplate, parameters) {
                const event = {
                    messageTemplate,
                    parameters,
                    level,
                    '@timestamp': new Date().toISOString(),
                    loggingSessionId,
                };
                consoleLogger(event);
                if (event.level != 'DEBUG' && (serverLogScheduler === null || serverLogScheduler === void 0 ? void 0 : serverLogScheduler.isRunning())) {
                    storageStrategy === null || storageStrategy === void 0 ? void 0 : storageStrategy.add(event);
                }
            }
            serverLogScheduler === null || serverLogScheduler === void 0 ? void 0 : serverLogScheduler.resume();
            return {
                logDebug(message, ...optionalData) {
                    structuredLog('DEBUG', message, optionalData);
                },
                logInformation(message, ...optionalData) {
                    structuredLog('INFO', message, optionalData);
                },
                logWarning(message, ...optionalData) {
                    structuredLog('WARN', message, optionalData);
                },
                logError(message, ...optionalData) {
                    structuredLog('ERROR', message, optionalData);
                },
                resumeServerLogs() {
                    serverLogScheduler === null || serverLogScheduler === void 0 ? void 0 : serverLogScheduler.resume();
                },
                pauseServerLogs() {
                    serverLogScheduler === null || serverLogScheduler === void 0 ? void 0 : serverLogScheduler.suspend();
                },
            };
        },
    };
    return builder;
}
exports.LogBuilder = LogBuilder;
//# sourceMappingURL=log-builder.js.map